import React from 'react';

interface ContextT {
    textos?: any,
    imagens?: any,
    configuracoes?: any,
    resumo?: any
}

const Context = React.createContext<ContextT>({});

export default Context;